!function ($, global) {
    'use strict';

    var document = global.document;
    var $window = $(global);
    var $html = $('html');
    var $body = $(document.body);

    var userAgent = navigator.userAgent;

    var isFrame;
    var isMobile = userAgent.match(/mobi/i);
    var isOSX = userAgent.match(/(iPad|iPhone|iPod|Macintosh)/g);

    var options = {
        step: 150,
        arrowScroll: 50,
        arrowDuration: 250
    };

    var smoothScroll;

    // Ancestor
    // ========

    var getOverflowAncestor = function () {

        var UID = '_overflowElementUID';
        var uid = 0;
        var cache = {};
        var $root = (navigator.userAgent.indexOf('AppleWebKit') === -1 || document.compatMode.indexOf('CSS') >= 0) ? $html : $body;

        var getUID = function ($element) {
            var data = $element.data();

            return data[UID] || (data[UID] = ++uid);
        };

        var updateCache = function ($ancestor, $elements) {
            $elements.each(function (index, element) {
                cache[getUID($(element))] = $ancestor;
            });
        };

        setInterval(function () {
            cache = {};
        }, 1e4);

        return function ($target) {
            var $element = $target;
            var $elements = $().add($target);
            var $ancestor;
            var rootScrollHeight = $root.prop('scrollHeight');
            var rootHeight = $root.height();
            var scrollHeight;
            var overflow;

            while ($element.length) {
                $ancestor = cache[getUID($element)];

                if (!$ancestor) {
                    scrollHeight = $element.prop('scrollHeight');

                    if (rootScrollHeight === scrollHeight) {
                        if (!isFrame || rootHeight + 10 < rootScrollHeight) {
                            $ancestor = $window; // scrolling root
                        }
                    } else if ($element.outerHeight() + 10 < scrollHeight) {
                        overflow = $element.css('overflow-y');

                        if (overflow === 'scroll' || overflow === 'auto') {
                            $ancestor = $element;
                        }
                    }
                }

                if ($ancestor) {
                    updateCache($ancestor, $elements);

                    return $ancestor;
                }

                $element = $element.parent();
                $elements = $elements.add($element);
            }

            if (!$ancestor) {
                updateCache($body, $elements);

                return $body;
            }
        }
    }();

    // Bind Event Handlers
    // ===================

    var bindEventHandlers = function () {
        var $activeElement = $body;

        var $roots = $html.add($body);

        var getClientHeight = function ($element) {
            return ($roots.is($element) ? $window : $element).height();
        };

        var keyArgs = {
            // space
            32: function (event, $element) {
                return {
                    options: {horizontal: false},
                    delta: (event.shiftKey ? -1 : 1) * getClientHeight($element) * 0.9
                };
            },

            // pageup
            33: function (event, $element) {
                return {options: {horizontal: false}, delta: -getClientHeight($element) * 0.9};
            },

            // pagedown
            34: function (event, $element) {
                return {options: {horizontal: false}, delta: getClientHeight($element) * 0.9};
            },

            // end
            35: function (event, $element) {
                var y = $element.prop('scrollHeight') - $element.scrollTop() - getClientHeight($element);
                return {options: {horizontal: false}, delta: y > 0 ? y + 10 : 0};
            },

            // home
            36: function (event, $element) {
                return {options: {horizontal: false}, delta: -$element.scrollTop()};
            },

            // left
            37: {options: {horizontal: true, duration: options.arrowDuration}, delta: -options.arrowScroll},

            // up
            38: {options: {horizontal: false, duration: options.arrowDuration}, delta: -options.arrowScroll},

            // right
            39: {options: {horizontal: true, duration: options.arrowDuration}, delta: options.arrowScroll},

            // down
            40: {options: {horizontal: false, duration: options.arrowDuration}, delta: options.arrowScroll}
        };

        var onKeyDown = function (event) {
            var target = event.target;
            var nodeName = target.nodeName.toLowerCase();
            var keyCode = event.keyCode;
            var $element;
            var key;

            if (event.defaultPrevented
                || /input|textarea|select|embed/i.test(nodeName)
                || target.isContentEditable
                || event.ctrlKey
                || event.altKey
                || event.metaKey
                || (event.shiftKey && keyCode !== 32)) {
                return true;
            }

            if (nodeName === 'button' && keyCode === 32) {
                return true;
            }

            $element = getOverflowAncestor($activeElement);

            key = keyArgs[keyCode];

            if (!key) {
                return true;
            }

            if ($.isFunction(key)) {
                key = key(event, $element);
            }

            smoothScroll($element.get(0), key.delta, key.options);

            return false;
        };

        var onMouseDown = function (event) {
            $activeElement = $(event.target);
        };

        var onWheel = function (event) {
            //var deltaX = event.deltaX * options.step;
            var delta = -(event.deltaY || event.deltaX) * options.step;
            var $target = $(event.target);
            var $overflowing = getOverflowAncestor($target);

            if (!$overflowing || event.defaultPrevented || ($activeElement.prop('nodeName') || '').toLowerCase() === 'embed') {
                return true;
            }

            smoothScroll($overflowing.get(0), delta, {
                horizontal: !event.deltaY
            });

            return false;
        };

        $window
            .on('mousedown', onMouseDown)
            .on('mousewheel', onWheel)
            .on('keydown', onKeyDown);
    };


    // Init
    // ====
    $(function () {
        isFrame = global.self !== global.top;

        smoothScroll = global.smoothScroll;

        if (smoothScroll && $.smoothScroll && $.smoothScroll.enabled && !isMobile && !isOSX) {
            bindEventHandlers();
        }
    });

}(jQuery, window);